// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dn7o0RZoAHR3No,
.vEJfO47NlIRe4J {
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  font-weight: var(--ds-font-weight-semibold, 600);
  line-height: 20px;
}
.vEJfO47NlIRe4J {
  display: flex;
  justify-content: space-between;
  padding: var(--ds-space-0, 0);
}
.vEJfO47NlIRe4J:hover,
.vEJfO47NlIRe4J:active {
  background-color: transparent;
}
.TcujlXMtjC2WYl {
  margin: var(--ds-space-0, 0);
}
.Aj8pyZXGHXSXtM {
  margin-right: var(--ds-space-075, 6px);
  transition: transform 0.2s ease-out;
}
.Aj8pyZXGHXSXtM.zzJetH3K2ArWeX {
  transform: rotate(180deg);
}
.LZeBUVcqKAv9Ra {
  height: auto;
}
.LZeBUVcqKAv9Ra.zzJetH3K2ArWeX {
  visibility: hidden;
  height: 0;
  overflow: hidden;
}
`, ""]);
// Exports
export var title = `Dn7o0RZoAHR3No`;
export var button = `vEJfO47NlIRe4J`;
export var buttonContainer = `TcujlXMtjC2WYl`;
export var icon = `Aj8pyZXGHXSXtM`;
export var collapsed = `zzJetH3K2ArWeX`;
export var content = `LZeBUVcqKAv9Ra`;
export default ___CSS_LOADER_EXPORT___;
